import React from 'react'
import { 
  makeStyles, 
  Typography, 
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  linkContainer: {
    display: 'flex',
    maxWidth: '100%'
  },
  linkTitle: {
    fontSize: 14,
    color: theme.palette.neutrals.low.dark,
    fontWeight: 600,
    paddingRight: 8,
    minWidth: 'fit-content'
  },
  linkWeb: {
    paddingTop: 0,
    fontSize: 14,
    fontWeight: 400,
    cursor: 'pointer',
    color: theme.palette.auxiliary.blue.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
  },
}))


export const AttachmentLink = ({ links }) => {
  const classes = useStyles();

  return (
    links.map((link, index) => {
      return (
        <div className={classes.linkContainer} key={index}>
          <Typography
            className={classes.linkTitle}
          >
          {`Link ${index+1}:`}
          </Typography>
          <a className={classes.linkWeb} href={link} target="_blank" rel="noopener noreferrer">{link}</a>
        </div>
      );
    })
  )
}
